import React from "react";
import { Link } from "react-router-dom";
import {
  FaUserTie,
  FaCalendarAlt,
  FaUserTie as FaParlamentar,
  FaClipboardList,
  FaGavel,
  FaFileAlt,
  FaChartBar,
  FaVoteYea,
} from "react-icons/fa";
import "./Dashboard.css";

const Dashboard = () => {
  const quadros = [
    {
      id: 1,
      titulo: "Parlamentares",
      descricao: "Vereadores e deputados",
      icone: <FaParlamentar />,
      cor: "#3b82f6",
      rota: "/institucional/parlamentares",
      ordem: 1,
    },
    {
      id: 2,
      titulo: "Mesa Diretora",
      descricao: "Gestão da mesa diretora do legislativo",
      icone: <FaUserTie />,
      cor: "#3b82f6",
      rota: "/institucional/mesa-diretora",
      ordem: 2,
    },
    {
      id: 3,
      titulo: "Comissões",
      descricao: "Comissões permanentes e temporárias",
      icone: <FaCalendarAlt />,
      cor: "#3b82f6",
      rota: "/institucional/comissoes",
      ordem: 3,
    },
    {
      id: 4,
      titulo: "Matérias Legislativas",
      descricao: "Projetos, indicações, requerimentos",
      icone: <FaFileAlt />,
      cor: "#3b82f6",
      rota: "/atividade-legislativa/materias-legislativas",
      ordem: 4,
    },
    {
      id: 5,
      titulo: "Pautas",
      descricao: "Pautas das sessões legislativas",
      icone: <FaClipboardList />,
      cor: "#3b82f6",
      rota: "/atividade-legislativa/pautas-sessoes",
      ordem: 5,
    },
    {
      id: 6,
      titulo: "Sessão Plenária",
      descricao: "Sessões plenárias e deliberações",
      icone: <FaGavel />,
      cor: "#3b82f6",
      rota: "/atividade-legislativa/sessoes-plenarias",
      ordem: 6,
    },
    {
      id: 7,
      titulo: "Votações",
      descricao: "Registro de votações das matérias",
      icone: <FaVoteYea />,
      cor: "#3b82f6",
      rota: "/atividade-legislativa/votacoes",
      ordem: 7,
    },
    {
      id: 8,
      titulo: "Relatórios",
      descricao: "Relatórios e estatísticas",
      icone: <FaChartBar />,
      cor: "#3b82f6",
      rota: "/atividade-legislativa/relatorios",
      ordem: 8,
    },
  ];

  // Ordenar os quadros pelo campo 'ordem'
  const quadrosOrdenados = [...quadros].sort((a, b) => a.ordem - b.ordem);

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Painel Legislativo</h1>
        <p>Sistema de Apoio ao Processo Legislativo</p>
      </div>

      <div className="quadros-grid">
        {quadrosOrdenados.map((quadro) => (
          <Link
            to={`/painel${quadro.rota}`}
            key={quadro.id}
            className="quadro-card"
            style={{ "--quadro-cor": quadro.cor }}
          >
            <div className="quadro-icon-container">
              <div
                className="quadro-icon"
                style={{
                  backgroundColor: quadro.cor,
                  color: "white",
                }}
              >
                {quadro.icone}
              </div>
            </div>
            <div className="quadro-content">
              <h3 className="quadro-titulo">{quadro.titulo}</h3>
              <p className="quadro-descricao">{quadro.descricao}</p>
            </div>
            <div className="quadro-footer">
              <span className="acessar-link">Acessar →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;